// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-f7dd86da5621ad2e21ba675655c8cab5"};